// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ir-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.ir-field__label {
  display: flex;
  gap: 2px;
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
}
.ir-field__label > span {
  color: var(--danger-default, #c23a2b);
}
.ir-field__message {
  min-height: 15px;
  color: var(--text-secondary, #506360);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}
.ir-input-shell {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  overflow: hidden;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.ir-input-shell:hover {
  border-color: var(--text-secondary, #506360);
}
.ir-input-shell:focus-within {
  border: 2px solid var(--interactive-default, #0f766e);
  padding-inline: 11px;
  box-shadow: none;
}
.ir-input-shell input,
.ir-input-shell select {
  flex: 1 1;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: 0;
  outline: 0;
  appearance: none;
  background: transparent;
  color: var(--text-primary, #142624);
  font: 400 14px var(--font-family-primary, "Lexend", sans-serif);
}
.ir-input-shell input::placeholder {
  color: var(--text-disabled, #8a9896);
  opacity: 1;
}
.ir-input-shell__icon,
.ir-select-shell > svg {
  display: flex;
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  color: var(--text-secondary, #506360);
  transition: transform var(--duration-fast, 150ms) var(--easing-standard, ease);
}
.ir-select-shell:focus-within > svg {
  color: var(--interactive-default, #0f766e);
}
.ir-select-shell:has(select:open) > svg {
  transform: rotate(180deg);
}
.ir-field--error .ir-input-shell {
  border-color: var(--danger-default, #c23a2b);
  box-shadow: none;
}
.ir-field--error .ir-field__message {
  color: var(--danger-default, #c23a2b);
}
.ir-field:has(input:disabled) .ir-input-shell,
.ir-field:has(select:disabled) .ir-input-shell {
  border-color: var(--border-subtle, #dce3e2);
  background: var(--surface-secondary, #f4f7f7);
}
.ir-field:has(input:disabled),
.ir-field:has(select:disabled) {
  opacity: 0.75;
}
.ir-control--sm .ir-input-shell {
  height: 32px;
  border-radius: 8px;
}
.ir-control--lg .ir-input-shell {
  height: 48px;
  border-radius: 12px;
}
.ir-choice {
  --choice-size: 20px;
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  padding-top: 2px;
  color: var(--text-primary, #142624);
  font: 400 14px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.ir-choice input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
.ir-choice__control {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 var(--choice-size);
  width: var(--choice-size);
  height: var(--choice-size);
  border: 1.5px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #fff);
}
.ir-checkbox .ir-choice__control {
  border-radius: 4px;
}
.ir-choice__control svg {
  width: 60%;
  height: 60%;
  color: #fff;
  stroke-width: 2.3;
  opacity: 0;
}
.ir-choice input:checked + .ir-choice__control,
.ir-checkbox--indeterminate .ir-choice__control {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
}
.ir-choice input:checked + .ir-choice__control svg,
.ir-checkbox--indeterminate .ir-choice__control svg {
  opacity: 1;
}
.ir-choice:hover .ir-choice__control {
  border-color: var(--interactive-default, #0f766e);
}
.ir-choice input:focus-visible + .ir-choice__control {
  box-shadow: none;
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: 2px;
}
.ir-choice--error .ir-choice__control {
  border-color: var(--danger-default, #c23a2b);
}
.ir-choice--error input:checked + .ir-choice__control {
  background: var(--danger-default, #c23a2b);
}
.ir-choice:has(input:disabled) {
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
  opacity: 0.75;
}
.ir-choice:has(input:disabled) .ir-choice__control {
  border-color: var(--border-subtle, #dce3e2);
  background: var(--surface-secondary, #f4f7f7);
}
.ir-choice:has(input:disabled) input:checked + .ir-choice__control {
  background: var(--border-default, #cdd6d4);
}
.ir-choice__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: var(--choice-size);
}
.ir-choice__copy small {
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: normal;
}
.ir-radio .ir-choice__control {
  border-radius: 50%;
}
.ir-radio input:checked + .ir-choice__control {
  border: 2px solid var(--interactive-default, #0f766e);
  background: var(--surface-primary, #fff);
  box-shadow: inset 0 0 0 calc((var(--choice-size) - 8px) / 2)
    var(--surface-primary, #fff);
}
.ir-radio input:checked + .ir-choice__control::after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--interactive-default, #0f766e);
}
.ir-choice--error.ir-radio input:checked + .ir-choice__control {
  border-color: var(--danger-default, #c23a2b);
}
.ir-choice--error.ir-radio input:checked + .ir-choice__control::after {
  background: var(--danger-default, #c23a2b);
}
.ir-control--sm.ir-choice {
  --choice-size: 16px;
  gap: 6px;
  font-size: 13px;
}
.ir-control--lg.ir-choice {
  --choice-size: 24px;
  font-size: 16px;
}
.ir-toggle__track {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  width: 38px;
  height: 22px;
  padding: 2px;
  border-radius: 999px;
  background: var(--border-default, #cdd6d4);
  transition: background 0.15s ease;
}
.ir-toggle__track > span {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.15);
  transition: transform 0.15s ease;
}
.ir-toggle input:checked + .ir-toggle__track {
  background: var(--interactive-default, #0f766e);
}
.ir-toggle input:checked + .ir-toggle__track > span {
  transform: translateX(16px);
}
.ir-control--sm.ir-toggle .ir-toggle__track {
  width: 32px;
  height: 18px;
}
.ir-control--sm.ir-toggle .ir-toggle__track > span {
  width: 14px;
  height: 14px;
}
.ir-control--sm.ir-toggle input:checked + .ir-toggle__track > span {
  transform: translateX(14px);
}
.ir-control--lg.ir-toggle .ir-toggle__track {
  width: 46px;
  height: 26px;
}
.ir-control--lg.ir-toggle .ir-toggle__track > span {
  width: 22px;
  height: 22px;
}
.ir-control--lg.ir-toggle input:checked + .ir-toggle__track > span {
  transform: translateX(20px);
}
`, "",{"version":3,"sources":["webpack://./src/components/FormControls/formControls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,6DAA6D;AAC/D;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,0DAA0D;AAC5D;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,+DAA+D;AACjE;AACA;EACE,oCAAoC;EACpC,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,8EAA8E;AAChF;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;;EAEE,2CAA2C;EAC3C,6CAA6C;AAC/C;AACA;;EAEE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mCAAmC;EACnC,+DAA+D;EAC/D,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,kDAAkD;EAClD,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;AACA;;EAEE,iDAAiD;EACjD,+CAA+C;AACjD;AACA;;EAEE,UAAU;AACZ;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;AACjC;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qDAAqD;EACrD,wCAAwC;EACxC;gCAC8B;AAChC;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;AAClC;AACA;EACE,+CAA+C;AACjD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".ir-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.ir-field__label {\n  display: flex;\n  gap: 2px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: normal;\n}\n.ir-field__label > span {\n  color: var(--danger-default, #c23a2b);\n}\n.ir-field__message {\n  min-height: 15px;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: normal;\n}\n.ir-input-shell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  height: 40px;\n  padding: 0 12px;\n  overflow: hidden;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.ir-input-shell:hover {\n  border-color: var(--text-secondary, #506360);\n}\n.ir-input-shell:focus-within {\n  border: 2px solid var(--interactive-default, #0f766e);\n  padding-inline: 11px;\n  box-shadow: none;\n}\n.ir-input-shell input,\n.ir-input-shell select {\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  appearance: none;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font: 400 14px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.ir-input-shell input::placeholder {\n  color: var(--text-disabled, #8a9896);\n  opacity: 1;\n}\n.ir-input-shell__icon,\n.ir-select-shell > svg {\n  display: flex;\n  flex: 0 0 auto;\n  width: 16px;\n  height: 16px;\n  color: var(--text-secondary, #506360);\n  transition: transform var(--duration-fast, 150ms) var(--easing-standard, ease);\n}\n.ir-select-shell:focus-within > svg {\n  color: var(--interactive-default, #0f766e);\n}\n.ir-select-shell:has(select:open) > svg {\n  transform: rotate(180deg);\n}\n.ir-field--error .ir-input-shell {\n  border-color: var(--danger-default, #c23a2b);\n  box-shadow: none;\n}\n.ir-field--error .ir-field__message {\n  color: var(--danger-default, #c23a2b);\n}\n.ir-field:has(input:disabled) .ir-input-shell,\n.ir-field:has(select:disabled) .ir-input-shell {\n  border-color: var(--border-subtle, #dce3e2);\n  background: var(--surface-secondary, #f4f7f7);\n}\n.ir-field:has(input:disabled),\n.ir-field:has(select:disabled) {\n  opacity: 0.75;\n}\n.ir-control--sm .ir-input-shell {\n  height: 32px;\n  border-radius: 8px;\n}\n.ir-control--lg .ir-input-shell {\n  height: 48px;\n  border-radius: 12px;\n}\n.ir-choice {\n  --choice-size: 20px;\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding-top: 2px;\n  color: var(--text-primary, #142624);\n  font: 400 14px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.ir-choice input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n.ir-choice__control {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 var(--choice-size);\n  width: var(--choice-size);\n  height: var(--choice-size);\n  border: 1.5px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #fff);\n}\n.ir-checkbox .ir-choice__control {\n  border-radius: 4px;\n}\n.ir-choice__control svg {\n  width: 60%;\n  height: 60%;\n  color: #fff;\n  stroke-width: 2.3;\n  opacity: 0;\n}\n.ir-choice input:checked + .ir-choice__control,\n.ir-checkbox--indeterminate .ir-choice__control {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n}\n.ir-choice input:checked + .ir-choice__control svg,\n.ir-checkbox--indeterminate .ir-choice__control svg {\n  opacity: 1;\n}\n.ir-choice:hover .ir-choice__control {\n  border-color: var(--interactive-default, #0f766e);\n}\n.ir-choice input:focus-visible + .ir-choice__control {\n  box-shadow: none;\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: 2px;\n}\n.ir-choice--error .ir-choice__control {\n  border-color: var(--danger-default, #c23a2b);\n}\n.ir-choice--error input:checked + .ir-choice__control {\n  background: var(--danger-default, #c23a2b);\n}\n.ir-choice:has(input:disabled) {\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n  opacity: 0.75;\n}\n.ir-choice:has(input:disabled) .ir-choice__control {\n  border-color: var(--border-subtle, #dce3e2);\n  background: var(--surface-secondary, #f4f7f7);\n}\n.ir-choice:has(input:disabled) input:checked + .ir-choice__control {\n  background: var(--border-default, #cdd6d4);\n}\n.ir-choice__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  line-height: var(--choice-size);\n}\n.ir-choice__copy small {\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: normal;\n}\n.ir-radio .ir-choice__control {\n  border-radius: 50%;\n}\n.ir-radio input:checked + .ir-choice__control {\n  border: 2px solid var(--interactive-default, #0f766e);\n  background: var(--surface-primary, #fff);\n  box-shadow: inset 0 0 0 calc((var(--choice-size) - 8px) / 2)\n    var(--surface-primary, #fff);\n}\n.ir-radio input:checked + .ir-choice__control::after {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--interactive-default, #0f766e);\n}\n.ir-choice--error.ir-radio input:checked + .ir-choice__control {\n  border-color: var(--danger-default, #c23a2b);\n}\n.ir-choice--error.ir-radio input:checked + .ir-choice__control::after {\n  background: var(--danger-default, #c23a2b);\n}\n.ir-control--sm.ir-choice {\n  --choice-size: 16px;\n  gap: 6px;\n  font-size: 13px;\n}\n.ir-control--lg.ir-choice {\n  --choice-size: 24px;\n  font-size: 16px;\n}\n.ir-toggle__track {\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 38px;\n  height: 22px;\n  padding: 2px;\n  border-radius: 999px;\n  background: var(--border-default, #cdd6d4);\n  transition: background 0.15s ease;\n}\n.ir-toggle__track > span {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.15);\n  transition: transform 0.15s ease;\n}\n.ir-toggle input:checked + .ir-toggle__track {\n  background: var(--interactive-default, #0f766e);\n}\n.ir-toggle input:checked + .ir-toggle__track > span {\n  transform: translateX(16px);\n}\n.ir-control--sm.ir-toggle .ir-toggle__track {\n  width: 32px;\n  height: 18px;\n}\n.ir-control--sm.ir-toggle .ir-toggle__track > span {\n  width: 14px;\n  height: 14px;\n}\n.ir-control--sm.ir-toggle input:checked + .ir-toggle__track > span {\n  transform: translateX(14px);\n}\n.ir-control--lg.ir-toggle .ir-toggle__track {\n  width: 46px;\n  height: 26px;\n}\n.ir-control--lg.ir-toggle .ir-toggle__track > span {\n  width: 22px;\n  height: 22px;\n}\n.ir-control--lg.ir-toggle input:checked + .ir-toggle__track > span {\n  transform: translateX(20px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
